<template>
  <category-form :value="category" :title="pageTitle" @submit="save">
    <template slot="actions">
      <form-button kind="submit" type="submit">Enregistrer</form-button>
      <form-button kind="delete" @click="remove">Supprimer</form-button>
      <form-button kind="cancel" @click="$router.go(-1)">Annuler</form-button>
    </template>
  </category-form>
</template>

<script>
import CategoryForm from "./CategoryForm.vue";

import CategoryDetailQuery from "./graphql/CategoryDetailQuery.gql";
import CategoryUpdateMutation from "./graphql/CategoryUpdateMutation.gql";
import CategoryRemoveMutation from "./graphql/CategoryRemoveMutation.gql";

export default {
  components: {
    CategoryForm
  },
  data() {
    return {
      category: null
    };
  },
  apollo: {
    category: {
      query: CategoryDetailQuery,
      skip() {
        return !this.$route.params.id;
      },
      variables() {
        return this.$route.params;
      }
    }
  },
  methods: {
    async save(data) {
      try {
        await this.$apollo.mutate({
          mutation: CategoryUpdateMutation,
          variables: {
            id: this.category.id,
            data
          }
        });
        this.$store.dispatch(
          "addNotificationSuccess",
          `Le métier a été mis à jour !`
        );
        this.$router.push({ name: "categories" });
      } catch (err) {
        if (err.message.match(/duplicate/)) {
          return this.$store.dispatch(
            "addNotificationError",
            `L'alias est déjà utilisé par un autre métier !`
          );
        }
        this.$store.dispatch("addNotificationError", err.message);
      }
    },
    async remove() {
      try {
        const { data } = await this.$apollo.mutate({
          mutation: CategoryRemoveMutation,
          variables: {
            id: this.category.id
          }
        });
        if (data.result) {
          this.$store.dispatch(
            "addNotificationSuccess",
            `Le métier a été supprimé`
          );
          this.$router.push({ name: "categories" });
        } else {
          this.$store.dispatch(
            "addNotificationError",
            `Le métier n'a pas été supprimé`
          );
        }
      } catch (err) {
        this.$store.dispatch("addNotificationError", err.message);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/categories/CategoryEdit.vue